import { api } from '../../services/api'

const state = () => ({
  items: [],
  current: null,
  loading: false,
  error: null
})

const getters = {
  all: s => s.items,
  byId: s => id => (s.items || []).find(x => String(x.id) === String(id)) || null
}

const mutations = {
  SET_ITEMS(state, items) {
    state.items = Array.isArray(items) ? items : []
  },
  SET_CURRENT(state, item) {
    state.current = item || null
  },
  ADD_ITEM(state, item) {
    if (!item) return
    state.items.unshift(item)
  },
  UPDATE_ITEM(state, item) {
    if (!item) return
    const i = state.items.findIndex(x => String(x.id) === String(item.id))
    if (i !== -1) state.items.splice(i, 1, item)
    else state.items.unshift(item)
  },
  REMOVE_ITEM(state, id) {
    state.items = (state.items || []).filter(x => String(x.id) !== String(id))
    if (state.current && String(state.current.id) === String(id)) state.current = null
  },
  SET_LOADING(state, v) {
    state.loading = !!v
  },
  SET_ERROR(state, e) {
    state.error = e || null
  }
}

const actions = {
  async list({ commit }) {
    commit('SET_LOADING', true)
    try {
      const { data } = await api.get('sale-invoices')
      const items = Array.isArray(data) ? data : (data?.items || data?.data || [])
      commit('SET_ITEMS', items)
      commit('SET_ERROR', null)
      return items
    } catch (e) {
      commit('SET_ERROR', e.response?.data?.error || e.message || 'Failed to load sale invoices')
      throw e
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async getById({ commit }, id) {
    commit('SET_LOADING', true)
    try {
      const { data } = await api.get(`sale-invoices/${id}`)
      const item = data?.data || data
      commit('SET_CURRENT', item)
      commit('SET_ERROR', null)
      return item
    } catch (e) {
      commit('SET_ERROR', e.response?.data?.error || e.message || 'Failed to load invoice')
      throw e
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async create({ commit }, payload) {
    try {
      const { data } = await api.post('sale-invoices', payload)
      const item = data?.data || data
      commit('ADD_ITEM', item)
      return item
    } catch (e) {
      commit('SET_ERROR', e.response?.data?.error || e.message || 'Failed to create invoice')
      throw e
    }
  },

  async update({ commit }, { id, payload }) {
    try {
      const { data } = await api.put(`sale-invoices/${id}`, payload)
      const item = data?.data || data
      commit('UPDATE_ITEM', item)
      return item
    } catch (e) {
      commit('SET_ERROR', e.response?.data?.error || e.message || 'Failed to update invoice')
      throw e
    }
  },

  async remove({ commit }, id) {
    try {
      await api.delete(`sale-invoices/${id}`)
      commit('REMOVE_ITEM', id)
      return true
    } catch (e) {
      commit('SET_ERROR', e.response?.data?.error || e.message || 'Failed to delete invoice')
      throw e
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
